<template lang="html">

<div style="padding:20px;">
  <div style="margin-bottom:20px;">
     <el-button @click="floorSet(1)" style="width:80px;" type="primary" size="small">新建</el-button>
  </div>
  <el-table
      :data="subData"
      border
      style="width: 100%">
      <el-table-column fixed="left" prop="controlFloor" align="center" label="空置楼层" />
      <el-table-column fixed="left" prop="vacantArea" align="center" width="150" label="空置面积(平方米)" />
      <el-table-column prop="decoration" width="150" align="center" label="装修情况" />
      <el-table-column prop="decorationInstructions" width="180" align="center" label="装修说明" />
      <el-table-column prop="actualUtilization" align="center" width="120" label="实际利用率">
          <template slot-scope="scope">
               {{ scope.row.actualUtilization }}%
          </template>
      </el-table-column>
      <el-table-column prop="floorHeight" width="120" align="center" label="层高(米)"/>
      <el-table-column prop="turnTowards" width="120" align="center" label="朝向" />
      <el-table-column prop="paymentMethod" width="120" align="center" label="交付方式" />
      <el-table-column width="180" align="center" label="报价(元/天/平方米)">
          <template slot-scope="scope">
             {{scope.row | priceTrans(1)}}
          </template>
      </el-table-column>
      <el-table-column prop="propertyCosts" width="180" align="center" label="物业费用(元/天/平方米)" />
      <el-table-column width="120" align="center" label="是否出售">
         <template slot-scope="scope">
            {{scope.row.isSell | strTrans}}
         </template>
      </el-table-column>
      <el-table-column width="180" align="center" label="出售说明" >
          <template slot-scope="scope">
             {{scope.row | priceTrans(3)}}
          </template>
      </el-table-column>
      <el-table-column width="180" align="center" label="最高售价">
          <template slot-scope="scope">
             {{scope.row | priceTrans(2)}}
          </template>
      </el-table-column>
      <el-table-column fixed="right" width="150" align="center" label="操作" >
           <template slot-scope="scope">
               <span @click="floorSet(2,scope.$index)" class="ibtn">编辑</span>
               <span @click="floorSet(3,scope.$index)" class="ibtn">删除</span>
           </template>
      </el-table-column>
  </el-table>

  <el-dialog
    :visible.sync="diaState"
    @closed="handleClose"
    width="600px">
    <template slot="title">
       <span>新建空置空间信息</span>
    </template>

    <div class="diaContent">
        <el-form :model="params" :show-message="false" :rules="rules" ref="ruleForm">
            <el-row>
                  <el-col class="iTerm" :span="8">
                       <div class="iName">
                          <span class="dot">*</span>
                          <span>空置位置</span>
                       </div>
                       <el-form-item prop="controlFloor">
                          <el-input maxlength="100" v-model="params.controlFloor" size="medium" />
                       </el-form-item>

                  </el-col>

                  <el-col class="iTerm" :span="8">
                       <div class="iName">
                          <span class="dot">*</span>
                          <span>空置面积（平方米）</span>
                       </div>
                       <el-form-item prop="vacantArea">
                          <el-input-number v-model="params.vacantArea" size="medium" />
                       </el-form-item>

                  </el-col>

                  <el-col class="iTerm" :span="8">
                       <div class="iName">
                          <span class="dot">*</span>
                          <span>装修情况</span>
                       </div>
                       <el-form-item prop="decorationId">
                         <dic-select code="zxqk"
                            :selectId="params.decorationId"
                            paramsKey="decoration"
                            @selectChange="selectChange"
                            plaText="装修情况"/>
                       </el-form-item>

                  </el-col>

                  <el-col class="iTerm" :span="8">
                       <div class="iName">
                          <span class="dot">*</span>
                          <span>实际利用率（%）</span>
                       </div>
                       <el-form-item prop="actualUtilization">
                          <el-input-number v-model="params.actualUtilization" size="medium" :max="100" />
                       </el-form-item>
                  </el-col>

                  <el-col class="iTerm" :span="8">
                       <div class="iName">
                          <!-- <span class="dot">*</span> -->
                          <span>层高（米）</span>
                       </div>
                       <el-input-number v-model="params.floorHeight" size="medium"/>
                  </el-col>

                  <el-col class="iTerm" :span="8">
                       <div class="iName">
                          <!-- <span class="dot">*</span> -->
                          <span>装修说明</span>
                       </div>
                       <el-input maxlength="100" v-model="params.decorationInstructions" size="medium" placeholder="请输入装修情况补充说明" />
                  </el-col>

                  <el-col class="iTerm" :span="8">
                       <div class="iName">
                          <span class="dot">*</span>
                          <span>朝向</span>
                       </div>
                       <el-form-item prop="turnTowardsId">
                           <all-select code="cx"
                              :selectId="params.turnTowardsId"
                              paramsKey="turnTowards"
                              @selectChange="selectChange"
                              plaText="朝向" />
                       </el-form-item>

                  </el-col>

                  <el-col class="iTerm" :span="8">
                       <div class="iName">
                          <span class="dot">*</span>
                          <span>交付方式</span>
                       </div>
                       <el-form-item prop="paymentMethodId">
                           <dic-select code="jffs"
                              :selectId="params.paymentMethodId"
                              paramsKey="paymentMethod"
                              @selectChange="selectChange"
                              plaText="交付方式"/>
                       </el-form-item>
                  </el-col>

                  <el-col v-if="params.isSell != 1" class="iTerm" :span="8">
                       <div class="iName">
                          <span class="dot">*</span>
                          <span>报价（元/平方米/天）</span>
                       </div>
                       <el-form-item prop="price">
                           <el-input-number v-model="params.price" size="medium" />
                       </el-form-item>

                  </el-col>

                  <el-col class="iTerm" :span="8">
                       <div class="iName">
                          <span class="dot">*</span>
                          <span>物业费（元/平方米/天）</span>
                       </div>
                       <el-form-item prop="propertyCosts">
                           <el-input-number v-model="params.propertyCosts" size="medium"/>
                       </el-form-item>
                  </el-col>

                  <el-col class="iTerm" :span="8">
                       <div class="iName">
                          <span class="dot">*</span>
                          <span>是否出售（整栋/部分）</span>
                       </div>
                       <el-form-item prop="isSell">
                           <el-select @change="sellChange" v-model="params.isSell" size="medium" placeholder="请选择">
                              <el-option
                                v-for="item in options"
                                :key="item.val"
                                :label="item.name"
                                :value="item.val">
                              </el-option>
                            </el-select>
                       </el-form-item>
                  </el-col>

            </el-row>

            <el-row v-if="params.isSell == 1">
              <el-col class="iTerm" :span="8">
                   <div class="iName">
                      <!-- <span class="dot">*</span> -->
                      <span>出售说明</span>
                   </div>
                   <el-input maxlength="20" v-model="params.sellingInstructions" size="medium" placeholder="请输入出售说明" />
              </el-col>
              <el-col class="iTerm" :span="16">
                   <div class="iName">
                      <span class="dot">*</span>
                      <span>最高售价</span>
                   </div>
                   <el-row>
                      <el-col :span="12">
                        <el-form-item prop="price">
                            <el-input-number v-model="params.price" size="medium"/>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" style="padding-left:10px;">
                        <el-form-item prop="sellingPriceUtilId">
                            <dic-select code="jgdw"
                               :selectId="params.sellingPriceUtilId"
                               paramsKey="sellingPriceUtil"
                               @selectChange="selectChange"
                               plaText="价格单位"/>
                        </el-form-item>
                      </el-col>
                   </el-row>


              </el-col>
            </el-row>

        </el-form>
    </div>

    <div class="diaFooter">
         <el-button @click="diaState = false" size="medium" >取消</el-button>
         <el-button @click="goSave" size="medium" type="primary">确定</el-button>
    </div>

  </el-dialog>


</div>

</template>

<script>
export default {
    props:['resData'],
    filters:{
       strTrans(e){
           let arr = ['出售','出租']
           return arr[e-1];
       },
       priceTrans(row,type){
           if(type == 1){
                if(row.isSell == 2){
                   return row.price;
                }else{
                   return '-';
                }
           }else if(type == 2){
                if(row.isSell == 1){
                  return row.price + row.sellingPriceUtil;
                }else{
                  return '-';
                }
           }else if(type == 3){
                if(row.isSell == 1){
                   return row.sellingInstructions;
                }else{
                   return '-';
                }
           }
       }
    },
    data(){

       var numCheck = (rule, value, callback) => {
           if(value <= 0){
              return callback(new Error());
           }else{
              callback();
           }
       }
       var propertyCostsCheck = (rule, value, callback) => {
          if(this.params.isSell==1){
            if(!value){
               return callback(new Error("请选择价格"));
            }else{
               callback();
            }
          }
           
       }
       return{
           subData:[],
           diaState:false,
           diaType:'',

           options:[
              { name:'是',val:1 },
              { name:'否',val:2 }
           ],

           changeX:null,

           params:{
               industrialSpaceId:'',     //产业空间id
               controlFloor:'',     //控制楼层
               vacantArea:'',     //空置面积（平方米）
               decoration:'',     //装修情况数据字典
               decorationId:'',     //装修情况id
               decorationInstructions:'',     //装修说明
               actualUtilization:'',     //实际利用率
               floorHeight:'',     //层高
               turnTowards:'',     //朝向数据字典
               turnTowardsId:'',     //朝向id
               paymentMethod:'',     //交付方式
               paymentMethodId:'',
               price:'',     //价格（元/天/平方米）（报价/售价）
               propertyCosts:'',     //物业费（元/天/平方米）
               isSell:'',     //是否出售（整栋/部分）1是2否
               sellingInstructions:'', // 出售说明
               sellingPriceUtil:'', //  价格单位
               sellingPriceUtilId:'' //  价格单位
           },

           rules:{
              controlFloor:[{required: true, trigger: 'blur'}],
              vacantArea:[{validator: numCheck, trigger: 'blur'}],
              decorationId:[{required: true, trigger: 'change'}],
              actualUtilization:[{validator: numCheck, trigger: 'blur'}],
              turnTowardsId:[{required: true, trigger: 'change'}],
              paymentMethodId:[{required: true, trigger: 'change'}],
              price:[{validator: numCheck, trigger: 'blur'}],
              propertyCosts:[{validator: numCheck, trigger: 'blur'}],
              sellingPriceUtilId:[{validator: propertyCostsCheck, trigger: 'change'}],
              isSell:[{required: true, trigger: 'change'}],
           }
       }
    },

    watch:{
        subData(e){
            this.$emit('floors',e.length);
        },
        resData(e){
            if(e){
                this.subData = e.industrialSpaceFloorList;
            }
        }
    },
    methods:{
       floorSet(type,inx){
      //  type  1 新建 2 编辑 3 删除
          if(type == 3){
             this.$confirm('确认删除楼层' + this.subData[inx].controlFloor +'吗？','提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
             }).then(() => {
                this.subData.splice(inx,1);
             })

          }else{
            this.diaState = true;
            if(type == 2){
                this.changeX = inx;
                let row = this.subData[inx];
                for(let key in this.params){
                    this.params[key] = row[key];
                }
            }
            if(type==1){
               this.params={
               industrialSpaceId:'',     //产业空间id
               controlFloor:'',     //控制楼层
               vacantArea:'',     //空置面积（平方米）
               decoration:'',     //装修情况数据字典
               decorationId:'',     //装修情况id
               decorationInstructions:'',     //装修说明
               actualUtilization:'',     //实际利用率
               floorHeight:'',     //层高
               turnTowards:'',     //朝向数据字典
               turnTowardsId:'',     //朝向id
               paymentMethod:'',     //交付方式
               paymentMethodId:'',
               price:'',     //价格（元/天/平方米）（报价/售价）
               propertyCosts:'',     //物业费（元/天/平方米）
               isSell:'',     //是否出售（整栋/部分）1是2否
               sellingInstructions:'', // 出售说明
               sellingPriceUtil:'', //  价格单位
               sellingPriceUtilId:'' //  价格单位
           }
            }
          }
       },

       selectChange(e){
           this.params[e.paramsKey] = e.name;
           this.params[e.paramsKey + 'Id'] = e.id;
       },

       goSave(){
           this.$refs.ruleForm.validate((valid) => {
              
               if(valid){
                  let temp = {};
                  for(let key in this.params){
                      temp[key] = this.params[key];
                  };
                  if(this.changeX || this.changeX == 0){
                     this.subData.splice(this.changeX,1,temp);
                  }else{
                     this.subData.push(temp);
                  }
                  this.diaState = false;
               }
           })
       },

       listSave(){
           return this.subData;
       },

       sellChange(){
           if(this.params.isSell == 2){
              this.sellingInstructions = '';
           }
       },

       handleClose(){
           this.$refs.ruleForm.resetFields();
           this.params.floorHeight = null;
           this.params.price = null;
           this.params.decorationInstructions = null;
           this.changeX = null;
       }

    }
}
</script>

<style lang="scss" scoped>

.iTerm{
   padding: 0 6px;
   height: 90px;
   .iName{
       margin-bottom: 8px;
       // height: 24px;
   }
   .dot{
       color: red;
       display: inline-block;
       vertical-align: middle;
   }
   .el-input-number--medium{
      width: 100%;
   }
}

.diaFooter{
   text-align: right;
   .el-button{
       width: 80px;
   }
}

.el-form-item{
   margin-bottom: 0px;
}

.ibtn{
   cursor: pointer;
}

.ibtn:nth-child(1){
  color: #409EFF;
  margin-right: 12px;
}

.ibtn:nth-child(2){
  color: red;
}

</style>

<style>
  .el-form-item__content{
     line-height: normal;
  }
</style>



// WEBPACK FOOTER //
// floorSave.vue?74c93b4a